import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import { AUTH_USER_TYPES } from "../constants/auth.constants";

const flattenRoutes = (routes = []) =>
  routes.flatMap((route) => [route, ...(route.subItems || [])]);

const pickMenu = (routes, path, label, extra = {}) => {
  const match = flattenRoutes(routes).find((item) => item.path === path);
  if (!match) return null;
  return {
    ...match,
    name: label,
    label,
    tooltip: extra.tooltip || label,
    subItems: extra.subItems,
    ...extra,
  };
};

export const getDefaultLanding = () => ({ path: "/dashboard", menuId: 1021 });

export const TENANT_WORKSPACE_PATHS = [
  "tenant-clients",
  "tenant-roles",
  "tenant-permissions",
  "tenant-user-profiles",
  "tenantusers",
];

export const isTenantWorkspacePath = (pathname = "") => {
  const path = String(pathname || "").replace(/^\/+/, "").split("/")[0];
  return TENANT_WORKSPACE_PATHS.includes(path);
};

const getTenantContextMenus = (routes = [], tenantName = "") => {
  const suffix = tenantName ? ` (${tenantName})` : "";
  return [
    pickMenu(routes, "tenant-clients", "Clients", {
      tooltip: `Clients${suffix}`,
    }),
    pickMenu(routes, "tenant-roles", "Roles", { tooltip: `Roles${suffix}` }),
    pickMenu(routes, "tenant-permissions", "Permissions", {
      tooltip: `Permissions${suffix}`,
    }),
    pickMenu(routes, "tenant-user-profiles", "User Profiles", {
      tooltip: `User Profiles${suffix}`,
    }),
    pickMenu(routes, "tenantusers", "Users", { tooltip: `Users${suffix}` }),
  ].filter(Boolean);
};

export const getSideMenus = (
  routes = [],
  userType = AUTH_USER_TYPES.SYSTEM,
  options = {}
) => {
  if (userType === AUTH_USER_TYPES.TENANT) {
    return [
      pickMenu(routes, "dashboard", "Dashboard"),
      pickMenu(routes, "clients", "Clients"),
      pickMenu(routes, "roles", "Roles"),
      pickMenu(routes, "permissions", "Permissions"),
      pickMenu(routes, "user-profiles", "User Profiles"),
      pickMenu(routes, "tenantusers", "Users"),
    ].filter(Boolean);
  }

  return [
    pickMenu(routes, "dashboard", "Dashboard"),
    {
      id: "system-scope",
      name: "System",
      label: "System",
      tooltip: "System resources",
      icon: <AdminPanelSettingsOutlinedIcon />,
      subItems: [
        pickMenu(routes, "clients", "Clients", { tooltip: "System Clients" }),
        pickMenu(routes, "roles", "Roles", { tooltip: "System Roles" }),
        pickMenu(routes, "systemusers", "Users", { tooltip: "System Users" }),
      ].filter(Boolean),
    },
    {
      id: "tenant-scope",
      name: "Tenants",
      label: options.activeTenantName
        ? `Tenants · ${options.activeTenantName}`
        : "Tenants",
      tooltip: options.activeTenantName
        ? `${options.activeTenantName} tenant resources`
        : "Open a tenant, then manage its resources",
      icon: <ApartmentOutlinedIcon />,
      subItems: [
        pickMenu(routes, "tenantmgmt", "Tenants", {
          id: "tenant-switch",
          tooltip: "View and select a tenant",
        }),
        ...getTenantContextMenus(routes, options.activeTenantName || ""),
      ].filter(Boolean),
    },
  ].filter(Boolean);
};
